import LoggerService from "./logger.service";
import environment from "../environments/environment.json"
 
export function windowLocation(url,token = "") {
  debugger;
  LoggerService.log(
    token,
    "",
    "windowLocation:: Going to redirect : "+url
  );
    // Validate the URL
    if (!url || typeof url !== 'string' || !url.trim()) {
      if(token !== "") {
        LoggerService.log(
          token,
          "",
          "windowLocation:: Invalid url error : "+url
        );
      }
      console.error('Invalid URL provided for redirect:', url);
      return false;
    }
  
    try {
      // Normalize the URL (ensure it has a protocol, e.g., https://)
      let normalizedUrl = url;
      if (!/^https?:\/\//i.test(url)) {
        normalizedUrl = window.location.protocol + '//' + url.replace(/^\/+/, '');
      }
  
      // Attempt redirect using window.location.assign
      window.location.assign(normalizedUrl);
  
      // Fallback: If the redirect doesn't happen within a short time, try again
      setTimeout(() => {
        if (window.location.href !== normalizedUrl) {
          console.warn('Redirect failed, retrying with window.location.replace');
          if(token !== "") {
            LoggerService.log(
              token,
              "",
              `windowLocation:: Redirect failed, retrying with window.location.replace  Url : ${url} Normalized url ${normalizedUrl}`
            );
          }
          window.location.replace(normalizedUrl);
        }
      }, 10000);
  
      return true;
    } catch (error) {
      console.error('Redirect failed:', error);
      // Fallback: Use a meta refresh tag for extreme cases
      const meta = document.createElement('meta');
      meta.httpEquiv = 'refresh';
      meta.content = `0;url=${url}`;
      document.head.appendChild(meta);
      return false;
    }
  }

  export function windowLocationRelayed(url,token = "") {
    debugger;
      LoggerService.log(
        token,
        "",
        "windowLocationRelayed:: Going to redirect : "+url
      );
      
      
      let params = `${url}`;
      let safeRedirectUrl = `${environment.SAFE_REDIRECT_APP}?symm_token=${token}&link=${encodeURIComponent(params)}`;
        // Validate the URL
        
  
        try {
          // Normalize the URL (ensure it has a protocol, e.g., https://)
          let normalizedUrl = safeRedirectUrl;
          if (!/^https?:\/\//i.test(url)) {
            normalizedUrl = window.location.protocol + '//' + url.replace(/^\/+/, '');
          }
      
          // Attempt redirect using window.location.assign
          window.location.assign(normalizedUrl);
      
          // Fallback: If the redirect doesn't happen within a short time, try again
          setTimeout(() => {
            if (window.location.href !== normalizedUrl) {
              console.warn('Redirect failed, retrying with window.location.replace');
              if(token !== "") {
                LoggerService.log(
                  token,
                  "",
                  `windowLocationRelayed:: Redirect failed, retrying with window.location.replace  Url : ${url} Normalized url ${normalizedUrl}`
                );
              }
              window.location.replace(normalizedUrl);
            }
          }, 10000);
      
          return true;
        } catch (error) {
          console.error('Redirect failed:', error);
          // Fallback: Use a meta refresh tag for extreme cases
          const meta = document.createElement('meta');
          meta.httpEquiv = 'refresh';
          meta.content = `0;url=${url}`;
          document.head.appendChild(meta);
          return false;
        }
      }